<template>
  <div>
    <index></index>
    <router-view></router-view>
    <bottom></bottom>
  </div>
</template>

<script>
import Index from "../components/keyan/Index";
import Dao from "../components/common/Dao.vue";
import Bottom from "../components/common/Bottom.vue";
export default {
  name: "Ke",
  components: {
    Dao,
    Bottom,
    Index,
  },
};
</script>

<style scoped></style>
